import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import moment from 'moment';
import momentLocaliser from 'react-widgets/lib/localizers/moment';
momentLocaliser(moment);

const DateTimeField = ({ input: { onChange, value }, label, meta: { error, dirty }, disabled, dateTimeFormat, time, defaultValue, min, max }) => {
    const cls = error ? 'datepicker-error form-group' : 'form-group';
    return (
        <div className={label ? cls : undefined}>
            {label && <label className='control-label col-sm-3'>{label}</label>}
            <div className={label ? 'controls col-sm-9' : undefined}>
                <DateTimePicker
                    disabled={disabled}
                    onChange={onChange}
                    format={dateTimeFormat}
                    time={time}
                    min={min}
                    max={max}
                    placeholder={time ? label : "дд-мм-гггг"}
                    value={value ? new Date(value) : defaultValue}
                />
                {error && <span style={{ color: "red", marginLeft: "5px" }}>{error}</span>}
            </div>
        </div>
    )
};

DateTimeField.defaultProps = {
    dateTimeFormat: "DD-MM-YYYY HH:mm:ss",
    time: true,
    defaultValue: new Date(),
    min: null
}

export default DateTimeField;


// WEBPACK FOOTER //
// ./src/components/common/DateTimeField.jsx